import { APP_NAME, imageFields, metafieldFields, productFields, productVariantFields, variantFields } from "./fields";
import { tagMetafield } from "./metafields/collection-metafields";
import type IQueryBuilderOptions from "gql-query-builder/build/IQueryBuilderOptions";

export const mediaImageFragment = {
  operation: "MediaImage",
  fields: ["id", { image: imageFields }],
  fragment: true,
};

export const videoFragment = {
  operation: "Video",
  fields: [
    "id",
    "alt",
    {
      sources: [
        {
          operation: "VideoSource",
          fields: ["url", "format"],
          fragment: true,
        },
      ],
    },
  ],
  fragment: true,
};

export const collectionFragment = {
  operation: "Collection",
  fields: ["handle", "title", "id", tagMetafield],
  fragment: true,
};

export const productFragment = {
  operation: "Product",
  fields: productFields,
  fragment: true,
};

export const productVariantFragment = {
  operation: "ProductVariant",
  fields: productVariantFields,
  fragment: true,
};

export const moneyFragment = {
  operation: "MoneyV2",
  fields: ["amount"],
  fragment: true,
};

export const metaObjectImageFragment = {
  operation: "Metaobject",
  fields: ["id", { fields: ["key", "value", { reference: [mediaImageFragment] }] }],
  fragment: true,
};

// Khakis 성수 재고 메타필드 프래그먼트
export const seongsuVariantStockMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "seongsu_stock")',
    alias: "seongsuStock",
  },
  fields: metafieldFields,
  variables: {},
};

// Khakis 연희 재고 메타필드 프래그먼트
export const yeonhuiVariantStockMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "yeonhui_stock")',
    alias: "yeonhuiStock",
  },
  fields: metafieldFields,
  variables: {},
};

export const variantMetafields: Record<string, IQueryBuilderOptions[]> = {
  tune: [],
  yeseyesee: [],
  thisisneverthat: [],
  khakis: [seongsuVariantStockMetafield, yeonhuiVariantStockMetafield],
  jknd: [],
};

export const metaObjectProductFragment = {
  operation: "Metaobject",
  fields: [
    "id",
    {
      fields: [
        "key",
        "value",
        {
          operation: "references(first: 120)",
          fields: [
            {
              edges: [
                {
                  node: [
                    {
                      operation: "Product",
                      fields: [
                        ...productFields,
                        {
                          operation: "variants(first: 40)",
                          fields: [{ edges: [{ node: [...productVariantFields] }] }],
                          variables: {},
                        },
                      ],
                      fragment: true,
                    },
                  ],
                },
              ],
            },
          ],
          variables: {},
        },
      ],
    },
  ],
  fragment: true,
};

export const productReferencesFragment = {
  operation: "references(first: 100)",
  fields: [
    {
      edges: [
        {
          node: [
            {
              operation: "Product",
              fields: [
                ...productFields,
                {
                  operation: "variants(first: 40)",
                  fields: [{ edges: [{ node: productVariantFields }] }],
                  variables: {},
                },
              ],
              fragment: true,
            },
          ],
        },
      ],
    },
  ],
  variables: {},
};

export const metaObjectImageProductFragment = {
  operation: "Metaobject",
  fields: [
    "id",
    {
      fields: [
        "key",
        "value",
        { reference: [mediaImageFragment, productFragment, videoFragment] },
        {
          operation: "references(first: 12)",
          fields: [
            {
              edges: [
                {
                  node: [
                    {
                      operation: "Product",
                      fields: [
                        ...productFields,
                        {
                          operation: { name: 'metafield(namespace: "info", key: "tag")', alias: "tag" },
                          fields: metafieldFields,
                          variables: {},
                        },
                        {
                          operation: "variants(first: 10)",
                          fields: [
                            {
                              edges: [
                                {
                                  node: [...variantFields, { product: ["handle"] }, ...variantMetafields[APP_NAME]],
                                },
                              ],
                            },
                          ],
                          variables: {},
                        },
                      ],
                      fragment: true,
                    },
                    {
                      operation: "MediaImage",
                      fields: ["id", mediaImageFragment],
                      fragment: true,
                    },
                  ],
                },
              ],
            },
          ],
          variables: {},
        },
      ],
    },
  ],
  fragment: true,
};
